import { NavLink } from 'react-router-dom';
import { useState } from 'react';
import styles from './NavBar.module.scss';
import Button from '../Button/Button';
import motusLogo from '../../../assets/images/logoMotus.png';
import { useNavigate } from 'react-router-dom';

const NavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const navigate = useNavigate();
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className={styles.nav}>
      <div className={styles.special}>
        <div className={styles.inner}>
          <NavLink to='/' onClick={closeMenu}>
            <img src={motusLogo} alt='logo' className={styles.logo}></img>
          </NavLink>

          {/* ====================================== */}
          {/* Toggle menu */}
          {/* ====================================== */}

          <div className={styles.hamburger} onClick={toggleMenu}>
            ☰
          </div>

          {/* ITEMS NAVBARs*/}
          <div className={`${styles.items} ${menuOpen ? styles.open : ''}`}>
            <NavLink
              to='/'
              end
              className={({ isActive }) =>
                isActive
                  ? `${styles.navLink} ${styles.activeLink}`
                  : styles.navLink
              }
              onClick={closeMenu}
            >
              Strona główna
            </NavLink>

            <NavLink
              to='/offers'
              className={({ isActive }) =>
                isActive
                  ? `${styles.navLink} ${styles.activeLink}`
                  : styles.navLink
              }
              onClick={closeMenu}
            >
              Oferta
            </NavLink>

            <NavLink
              to='/aboutUs'
              className={({ isActive }) =>
                isActive
                  ? `${styles.navLink} ${styles.activeLink}`
                  : styles.navLink
              }
              onClick={closeMenu}
            >
              O nas
            </NavLink>

            <NavLink
              to='/team'
              className={({ isActive }) =>
                isActive
                  ? `${styles.navLink} ${styles.activeLink}`
                  : styles.navLink
              }
              onClick={closeMenu}
            >
              Zespół
            </NavLink>

            <NavLink
              to='/priceList'
              className={({ isActive }) =>
                isActive
                  ? `${styles.navLink} ${styles.activeLink}`
                  : styles.navLink
              }
              onClick={closeMenu}
            >
              Cennik
            </NavLink>
            <NavLink
              to='/articles'
              className={({ isActive }) =>
                isActive
                  ? `${styles.navLink} ${styles.activeLink}`
                  : styles.navLink
              }
              onClick={closeMenu}
            >
              Artykuły
            </NavLink>

            <NavLink
              to='/contact'
              className={({ isActive }) =>
                isActive
                  ? `${styles.navLink} ${styles.activeLink}`
                  : styles.navLink
              }
              onClick={closeMenu}
            >
              Kontakt
            </NavLink>
            <Button
              onClick={() => {
                closeMenu();
                navigate('/contact');
              }}
            >
              Umów wizytę
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
